import { Logo } from "@/components/brand/logo";
import { ThemeToggle } from "@/components/theme/theme-toggle";
import { brand } from "@/lib/brand";

export function SiteHeader({
  showThemeToggle = true,
}: {
  showThemeToggle?: boolean;
}) {
  return (
    <header className="bg-card/95 shadow-[0_1px_3px_hsla(0,0%,0%,.1)] backdrop-blur-sm">
      <div className="mx-auto flex max-w-2xl items-center justify-between gap-4 px-4 py-3 sm:py-4">
        <Logo />
        <div className="flex items-center gap-3">
          <p className="hidden text-right text-xs leading-snug text-muted-foreground sm:block">
            {brand.tagline}
          </p>
          {showThemeToggle ? <ThemeToggle /> : null}
        </div>
      </div>
    </header>
  );
}
